import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { getBaseUrl } from "../../Utils/Utils";
import { registerError } from "../actions/action";

const registerUser = createAsyncThunk('register/user', async(userData,{dispatch}) =>{
    try {
        // Perform the POST request
        const url = getBaseUrl();
        const response = await axios.post(`${url}/user/register`, userData);
  
        return(response.data);
      } catch (error) {
        console.log(error)
        // const responseObj = {
        //   message:"Something went wrong. please try after sometime",
        //   statusType: error.response.status
        // }
        dispatch(registerError(error?.response?.data || error.message));
      }
});

export {registerUser};